// to make dropdown open while choosing from checkbox
$('.searchQuestions .dropdown .dropdown-menu').on('click', function (e) {
  e.stopPropagation();
});
// open dropdown-menu when click on dropdown
$('.searchQuestions .dropdown').on('click', function (e) {
  $(this).siblings().find('.dropdown-menu').slideUp(100);
  $(this).siblings().find('.btn').removeClass('active-btn');
  $(this).find('.dropdown-menu').slideToggle(200);
  $(this).find('.btn').toggleClass('active-btn');
});

// close dropdown on click anywhere except dropdown-menu itself
$(window).click(function (event) {
  if (!$(event.target).closest('.dropdown, .dropdown-menu, .dropdown-item').length) {
    $('body').find('.dropdown-menu').slideUp(200);
    $('body').find('.dropdown .btn').removeClass('active-btn');
  }
});

// make dropdown button color blue when at least one number in choosed
//  add badge with number
function dropdownCount() {
  const $menu = $(this).parents('.dropdown-menu');
  const $btn = $menu.prev();
  const $badge = $btn.find('.badge');
  const count = $menu.find('input:checked').length;
  $badge.text(count);
  if ($badge.text() >= 1) {
    $btn.addClass('radio-color');
    $badge.addClass('radio-color');
  } else {
    $btn.removeClass('radio-color');
    $badge.removeClass('radio-color');
  }
}

$('.dropdown-item').on('click', 'input', dropdownCount)



//////////////////
// WEBPACK FOOTER
// ./src/js/components/layout/_dropdown.js
// module id = 14
// module chunks = 0